import type { LeatherNetworkName } from '../LeatherBitcoinInjectedProvider.types';

export const convertNetworkIdToLeatherNetworkName = (
  networkId: string
): LeatherNetworkName | undefined => {
  if (networkId === '1') {
    return 'mainnet';
  }

  if (networkId === '2') {
    return 'testnet';
  }

  if (networkId === '3') {
    return 'signet';
  }

  return undefined;
};
